var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-list__content" }, [
    _c("h2", { staticClass: "c-list__title" }, [
      _c("a", { staticClass: "c-list__link", attrs: { href: _vm.item.url } }, [
        _vm._v("\n      " + _vm._s(_vm.item.title) + "\n      "),
        _c(
          "svg",
          {
            staticClass: "c-list__file-icon",
            attrs: { focusable: "false", "aria-hidden": "true" }
          },
          [
            _c(
              "use",
              _vm._b(
                {},
                "use",
                { "xlink:href": "#" + _vm.item.extension },
                false
              )
            )
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v(_vm._s(_vm.item.extension))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("dl", { staticClass: "c-list__meta" }, [
      _c("dt", { staticClass: "c-list__meta-title" }, [_vm._v("Size")]),
      _vm._v(" "),
      _c("dd", { staticClass: "c-list__meta-detail" }, [
        _vm._v(_vm._s(_vm.item.size))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "c-list__meta-title" }, [_vm._v("Modified")]),
      _vm._v(" "),
      _c("dd", { staticClass: "c-list__meta-detail" }, [
        _c("time", { attrs: { datetime: _vm.item.dateTime } }, [
          _vm._v(_vm._s(_vm._f("formatDate")(_vm.item.dateTime)))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-705221b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705221b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/searches/results/SearchItemDoc.vue
// module id = 516
// module chunks = 0